import type { IEmployeePortalRepository } from '@domain/data-contracts/employee-portal-repository.interface';
import type {
  EmployeeNextStep,
  EmployeeTask,
  EmployeeTaskDetail,
} from '@domain/models/employee-task.interface';

export class EmployeePortalService {
  public constructor(private readonly repo: IEmployeePortalRepository) {}

  public listMyTasks(): Promise<readonly EmployeeTask[]> {
    return this.repo.listMyTasks();
  }

  public getTaskById(id: string): Promise<EmployeeTaskDetail> {
    return this.repo.getTaskById(id);
  }

  public getTaskByBarcode(barcode: string): Promise<EmployeeTask | null> {
    return this.repo.getTaskByBarcode(barcode);
  }

  public completeTask(id: string): Promise<EmployeeTask> {
    return this.repo.completeTask(id);
  }

  public listNextSteps(id: string): Promise<readonly EmployeeNextStep[]> {
    return this.repo.listNextSteps(id);
  }

  public handoffTask(id: string, nextStepId: string): Promise<EmployeeTask> {
    return this.repo.handoffTask(id, nextStepId);
  }
}
